import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';
import * as React from 'react';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { Messages } from '../../../codegen/Localize';
import { ActionDialogBodyWithInlineErrorMessage, ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState } from '../../../commonInfra/dialogs/ActionDialogBodyWithInlineErrorMessage';
import { openReactActionDialog } from '../../../commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '../../../commonInfra/dialogs/style/TabDialogWidth';
import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { SiteSettingsErrorCode } from '../../helpers/ErrorCodes';
import { L10n } from '../../L10n/L10n';
import { Set } from '../../models/Set';
import { Sites } from '../../resources/Sites';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '../../services/ToasterService';

const initialDialogState: ActionDialogBodyWithInlineErrorMessageState = {
};

function showSuspendSitesActionDialog(sites: Set<ISiteSettingsForServerAdmin>): Promise<IResult> {
  const SitesService = ServiceLocator.get<Sites>('Sites');
  let message: string = Messages.confirmSuspendSites({SITE_NAME: L10n.elideIfLong(sites.first().settings.name), ITEM_COUNT: sites.size(), ITEM_COUNT_LOC: L10n.localizedCount(sites.size())});
  const initialBodyProps: ActionDialogBodyWithInlineErrorMessageProps = {dialogMessage: message};
  const dialogInstance = openReactActionDialog<ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState, IResult>({
    title: Messages.suspendSites(),
    actionName: Messages.suspendButtonConfirm({ ITEM_COUNT: sites.size() , ITEM_COUNT_LOC: L10n.localizedCount(sites.size()) }),
    actionDisabled: (props: ActionDialogBodyWithInlineErrorMessageProps, state: ActionDialogBodyWithInlineErrorMessageState) => {return false;},
    isActionDelete: true,
    action: (_, state, updateDialogState) => {
      return suspendSitesAction(updateDialogState, sites);
    },
    dialogWidth: TabDialogWidth.width375px,
    bodyComponent: ActionDialogBodyWithInlineErrorMessage,
    dismissDialogOnActionFailed: false,
    initialBodyProps,
    initialDialogState
  });
  return Promise.resolve(dialogInstance.result);
}

async function suspendSitesAction(
  updateDialogState: React.Dispatch<MergeOrUpdateStateAction<ActionDialogBodyWithInlineErrorMessageState>>,
  sites: Set<ISiteSettingsForServerAdmin>): Promise<IResult> {
  const SitesService = ServiceLocator.get<Sites>('Sites');
  const result = await SitesService.suspend(sites.keys());
  if (result.errors && result.errors.length) {
    if (result.errors.length === 1 && result.errors[0].code === SiteSettingsErrorCode.AttemptedToSuspendDefaultSite) {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.siteSettingsFailedAttemptedToSuspendDefaultSite()});
      ToasterService.instance.pop({
        type: ToastType.Info,
        text: Messages.sitesSuspendSuccess({
          ITEM_COUNT: sites.size() - 1,
          ITEM_COUNT_LOC: L10n.localizedCount(sites.size() - 1)
        })
      });
      return Promise.resolve(result);
    } else {
      updateDialogState({errorMessage: Messages.sitesSuspendFailed()});
      return Promise.reject();
    }
  } else {
    ToasterService.instance.pop({
      type: ToastType.Info,
      text: Messages.sitesSuspendSuccess({
        ITEM_COUNT: sites.size(),
        ITEM_COUNT_LOC: L10n.localizedCount(sites.size())
      })
    });
    return Promise.resolve(result);
  }
}

export const SuspendSitesAction = {
  showSuspendSitesActionDialog
};
